import type { SVGProps } from "react";
export interface HurricaneIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HurricaneIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HurricaneIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.789 2.6c2.088-1.173 6.66-2.985 13.397-.43.735.278 1.01.993.923 1.577-.085.57-.53 1.15-1.266 1.25-.656.089-1.224.205-1.7.322a9.77 9.77 0 0 1 2.59 7.64c-.33 3.343-2.276 6.253-4.656 7.902l-.48.313c-1.814 1.101-6.303 3.24-13.117.897l-.666-.242c-.735-.279-1.01-.994-.923-1.578.085-.57.53-1.15 1.266-1.25l.79-.125c.333-.061.636-.13.909-.197a9.77 9.77 0 0 1-2.588-7.64c.351-3.566 2.54-6.638 5.135-8.213L7.79 2.6Zm9.742.835c-4.355-.892-7.263.348-8.654 1.134l-.306.18C6.54 5.98 4.785 8.444 4.507 11.26a7.54 7.54 0 0 0 3.214 6.945h.002l.001.001.067.053a1 1 0 0 1 .065.057q.032.033.063.068c.068.075.13.159.177.255a1.2 1.2 0 0 1 .098.352q.009.06.01.116 0 .06-.005.119-.003.045-.01.09a1 1 0 0 1-.056.212 1.1 1.1 0 0 1-.125.243 1.1 1.1 0 0 1-.2.215 1 1 0 0 1-.148.108 1 1 0 0 1-.084.047l-.001.002-.003-.005-.005.002.003.004q-.016.006-.054.022a10 10 0 0 1-1.049.396c4.706.964 7.724-.56 8.962-1.311 2.03-1.232 3.786-3.696 4.064-6.511a7.54 7.54 0 0 0-2.817-6.65l-.399-.297-.001-.001a1 1 0 0 1-.135-.111l-.063-.068a1.1 1.1 0 0 1-.174-.255 1.1 1.1 0 0 1-.088-.265q-.008-.04-.012-.083a1 1 0 0 1-.006-.238q.004-.045.01-.092.013-.067.034-.132.013-.044.028-.086.046-.122.122-.235a1.1 1.1 0 0 1 .299-.293q.018-.013.038-.026a1 1 0 0 1 .098-.051l.001-.002v.002h.003l-.001-.003.054-.025.035-.015c.157-.07.5-.214 1.012-.38Z"
      />
      <path
        fill={color}
        d="M14.874 12a2.875 2.875 0 1 0-5.75 0 2.875 2.875 0 0 0 5.75 0m2.25 0a5.124 5.124 0 1 1-10.248 0 5.124 5.124 0 0 1 10.248 0"
      />
    </svg>
  );
}
